import {
  Injectable,
  Type
} from '@angular/core';
import {
  COMPONENT_DEFINITION_METADATA_KEY,
  COMPONENT_ID_METADATA_KEY
} from './metadata-keys';
import { NGXLogger } from 'ngx-logger';
import {
  getMetadataKeys,
  getMetadata
} from '@digitaix/helpers';
import { ComponentDefinition } from '@digitaix/types';

@Injectable({ providedIn: 'root' })
export class ComponentRegistryService {

  public registry = new Map<string, ComponentDefinition<any>>();

  constructor(public logger: NGXLogger) {}

  public register(id: string, definition: ComponentDefinition<any>): void {
    this.registry.set(id, definition);
  }

  public add(component: Type<any>): void {

    const id = getMetadata<string>(COMPONENT_ID_METADATA_KEY, component);
    const definition = getMetadata<ComponentDefinition<any>>(COMPONENT_DEFINITION_METADATA_KEY, component);

    if (!id) {
      this.logger.error(`[ComponentRegistryService::add] component has not a defined id`, getMetadataKeys(component));
      throw new Error(`[ComponentRegistryService::add] component has not a defined id`)
    }

    this.register(id, { ...definition, component });

  }

  public getDefinition<T>(id: string): ComponentDefinition<T> {
    if (!this.registry.has(id)) {
      throw new Error(`[ComponentRegistryService::getDefinition] Component definition with id '${id}' is not registered`);
    }
    return this.registry.get(id);
  }

}
